<template>
  <div class="">
    <div class="row items-center cursor-pointer" style="height: 40px">
      <div
        v-ripple:grey
        class="border-full bg-grey-2 full-height q-px-sm row items-center relative-position"
        @click="sub"
      >
        <q-icon name="eva-minus" color="dark"></q-icon>
      </div>

      <div
        class="col full-height"
        :class="[error ? 'border-full-red' : 'border-top border-bottom']"
      >
        <input
          v-model.number="model"
          type="number"
          class="text-center text-caption text-dark text-weight-medium q-px-sm"
        />
      </div>

      <div
        v-ripple:grey
        class="border-full bg-grey-2 full-height q-px-sm row items-center relative-position"
        @click="add"
      >
        <q-icon name="eva-plus" color="dark"></q-icon>
      </div>
    </div>

    <div v-if="error" class="text-red text-caption text-center">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",

  props: {
    value: {
      type: [Number, String],
      default: "",
    },

    disable: {
      type: Boolean,
      default: false,
    },

    upperLimit: {
      type: Number,
      default: 100,
    },

    error: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      model: 0,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function () {
        this.model = Number(this.value) || 0;
      },
    },

    model() {
      this.$emit("input", this.model);
    },
  },

  methods: {
    click(e) {
      e.stopPropagation();
    },

    sub() {
      if (this.model <= 0) return;

      this.model--;
    },

    add() {
      this.model++;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
}
</style>
